import React from 'react';
import { connect } from 'react-redux';
import { Row } from "antd";
import PropTypes from 'prop-types';
import { ProcessingContainer, SpaceBetween, FlexCenter, ViewContrLabel, ViewContrValue } from './styles';
import Preloader from "../../../../../../../../CommonComponents/Preloader/Preloader";
import { getPrimaryAccount } from "../../../../../../../../utils/sessionUtil";
import { confirmationProcessingDetailsState } from "../../../../selectors";

export function ConfirmationProcessingDetails(props) {
    if(props.currentTransactionData){     
         let transactionStatus;
         const { currentTransactionData } = props;
         const { checks, funds, securities, specialAssets, wires, backdatedFlag, rkOnlyFlag } = currentTransactionData;
         checks.length && (transactionStatus = checks[0].giftStatus.extDescription);
         funds.length && (transactionStatus = funds[0].giftStatus.extDescription);
         securities.length && (transactionStatus = securities[0].giftStatus.extDescription);
         specialAssets && specialAssets.length && (transactionStatus = specialAssets[0].giftStatus.extDescription);
         wires.length && (transactionStatus = wires[0].giftStatus.extDescription); 
  return (
    <ProcessingContainer>
      <SpaceBetween>
      <Row type="flex">
      <FlexCenter marginBottom="15px" lg={8} md={12} xs={24}>
        <ViewContrLabel > Transaction ID</ViewContrLabel>
        <ViewContrValue marginLeft="15px" >{ 
        props.currentTransactionData ? `${props.currentTransactionData.transactionId} ${(transactionStatus != "Cancelled" && !rkOnlyFlag && backdatedFlag ? 
        " *": "")}` : ""}</ViewContrValue>
        </FlexCenter>
        <FlexCenter isAccountName marginBottom="15px" lg={20} md={20} xs={20}>
          <ViewContrLabel>Account Name</ViewContrLabel>
          <ViewContrValue isWordBreak marginLeft="15px">{ getPrimaryAccount() ? (!getPrimaryAccount().accountName ? <div>&mdash;</div> : getPrimaryAccount().accountName) : ""}</ViewContrValue>
        </FlexCenter>
        <FlexCenter marginBottom="15px" lg={8} md={24} xs={24}>
          <ViewContrLabel>Account Number</ViewContrLabel>
            <ViewContrValue marginLeft="15px">{ getPrimaryAccount() ? getPrimaryAccount().accountNumber : ""}</ViewContrValue>
        </FlexCenter> 
       </Row>
      </SpaceBetween>
    </ProcessingContainer>
  );
}else{
  return (<Preloader />);
}
}

ConfirmationProcessingDetails.propTypes = {
  currentTransactionData: PropTypes.object
}

const mapStateToProps = state => ({
  ...confirmationProcessingDetailsState(state.toJS())
});

export default connect(mapStateToProps, null)(ConfirmationProcessingDetails);
